import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _FunctionalID, _NoveltyAccount, _OutputAuthorizationRequest, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { OutputAuthorizationItem } from "../../../../../Inventories-Warehouses/OutputAuthorizationRequest/OutputAuthorizationItem/OutputAuthorizationItem";
import { VisorAnyDocument } from "../../../../../documents/VisorAnyDocument";
import { Alert } from "../../../../../theme/Component/Alert";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Aprove: string;
}

type SignedApprove = {
    IDAccount: number;
    Approved: boolean;
    Date: string;
};

export const SOLAUTSAL003 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};

    const { instance, bean, setBean } = useDataBean(_OutputAuthorizationRequest)

    const [doc, setDoc] = useState<any>({});

    useEffect(() => {
        if (props.IDOutputAuthorizationRequest) {
            instance.getPdfSalidaAlmacen(_single.getAccountID(), props.IDOutputAuthorizationRequest).then(
                (resp) => {
                    setDoc(resp)
                }
            ).catch(err => { toast.error(err) })
        }
    }, [props.IDOutputAuthorizationRequest])

    const onExportMap = () => {
        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Documento": doc.Name,
                "URL de descarga": doc.URL,
            })
        );
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({
                DocumentUrl: doc.URL
            })
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ doc })
        }
    }

    return (
        <div className="row">
            <div className="col-md-12" style={{ maxHeight: "700px", overflow: "auto" }}>
                {doc.TypeName ?
                    <VisorAnyDocument url={doc.URL} type={doc.TypeName} />
                    :
                    <Alert clase="info" children={`No se genero el documento Correctamente`} />
                }
            </div>
            <div className="col-md-4">
                <BasicButton useMargin disable={!doc.URL} eventClick={() => { onExportMap() }} icon="ri-send-plane-line"  >Continuar</BasicButton>
            </div>
        </div>
    );
}